import React, { FC } from 'react';

import { Switch } from '@epoch-ui/components/Switch/switch';

import { useRSVPControlModalContext } from '../rsvpControlContext';

export const NotificationSettingsSection: FC = () => {
  const { sendNotifications, setSendNotifications, swapGuest } = useRSVPControlModalContext();
  return (
    <div className="tw-flex tw-items-start tw-gap-4 tw-self-stretch">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <span className="tw-font-medium">Send update notifications</span>
        <span className="tw-text-xs tw-text-primary-grey">
          Update notifications will be sent in accordance with the guest{swapGuest ? `s' ` : `'s `}
          <a
            href="https://help.epochapp.com/articles/update-your-profile-and-settings"
            target="_blank"
            rel="noreferrer"
          >
            notification settings
          </a>
        </span>
      </div>
      <Switch
        checked={sendNotifications}
        onCheckedChange={(checked) => setSendNotifications(checked)}
      />
    </div>
  );
};
